<template>
  <div id="courseCategory">
    <!-- 面包导航 -->
    <el-breadcrumb
      separator="/"
      style="padding-left: 10px; padding-bottom: 10px; font-size: 12px"
    >
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>课程管理</el-breadcrumb-item>
      <el-breadcrumb-item>分类管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 分类列表卡片区 -->
    <el-card class="box-card">
      <el-form :inline="true" ref="form" :model="queryMap" label-width="90px">
        <el-form-item label="分类名称">
          <el-input
            @keyup.enter.native="searchCategory"
            @clear="searchCategory"
            clearable
            v-model="queryMap.categoryName"
            placeholder="请输入分类名称查询"
          ></el-input>
        </el-form-item>

        <el-form-item label="分类类型">
          <el-select
            clearable
            @change="searchCategory"
            @clear="searchCategory"
            v-model="queryMap.categoryType"
            placeholder="请选择分类类型"
          >
            <el-option label="课程分类" value="1"></el-option>
            <el-option label="资源分类" value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="层级">
          <el-select
            clearable
            @change="searchCategory"
            @clear="searchCategory"
            v-model="queryMap.level"
            placeholder="请选择层级"
          >
            <el-option label="一级分类" value="1"></el-option>
            <el-option label="二级分类" value="2"></el-option>
            <el-option label="三级分类" value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="状态">
          <el-select
            clearable
            @change="searchCategory"
            @clear="searchCategory"
            v-model="queryMap.status"
            placeholder="请选择状态"
          >
            <el-option label="正常" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item style="margin-left: 50px">
          <el-button @click="reset" icon="el-icon-refresh">重置</el-button>
          <el-button
            type="primary"
            @click="searchCategory"
            icon="el-icon-search"
            >查询</el-button
          >
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="addDialogVisible = true"
            v-hasPermission="'courseCategory:add'"
            >添加分类</el-button
          >
        </el-form-item>
      </el-form>

      <!-- 表格区域 -->
      <el-table
        v-loading="loading"
        :data="categoryList"
        border
        style="width: 100%"
        height="660"
      >
        <el-table-column label="#" prop="id" width="60"></el-table-column>
        <el-table-column prop="categoryName" label="分类名称" width="200">
          <template slot-scope="scope">
            <!-- 通过缩进展示层级关系 -->
            <span
              :style="{ 'padding-left': (scope.row.level - 1) * 20 + 'px' }"
            >
              <i
                v-if="scope.row.level > 1"
                class="el-icon-arrow-right"
                style="margin-right: 5px"
              ></i>
              {{ scope.row.categoryName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="parentCategoryName"
          label="父分类"
          width="180"
        ></el-table-column>
        <el-table-column prop="categoryType" label="分类类型" width="120">
          <template slot-scope="scope">
            <el-tag :type="scope.row.categoryType === 1 ? 'primary' : 'info'">
              {{ scope.row.categoryType === 1 ? "课程分类" : "资源分类" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="level" label="层级" width="100">
          <template slot-scope="scope"> {{ scope.row.level }}级分类 </template>
        </el-table-column>
        <el-table-column
          prop="sort"
          label="排序权重"
          width="100"
        ></el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              @change="changeStatus(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-button
              v-hasPermission="'courseCategory:edit'"
              size="mini"
              type="primary"
              icon="el-icon-edit-outline"
              @click="edit(scope.row.id)"
              :disabled="scope.row.level === 3"
            >
            </el-button>
            <el-button
              v-hasPermission="'courseCategory:delete'"
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click="del(scope.row.id)"
              :disabled="hasChildren(scope.row.id)"
            >
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 10px"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryMap.pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="queryMap.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>

      <!-- 添加对话框 -->
      <el-dialog
        title="添加分类"
        @close="closeDialog"
        :visible.sync="addDialogVisible"
        width="60%;"
      >
        <el-form
          :model="addForm"
          :label-position="labelPosition"
          :rules="formRules"
          ref="addFormRef"
          label-width="120px"
        >
          <el-form-item label="分类名称" prop="categoryName">
            <el-input
              v-model="addForm.categoryName"
              placeholder="请输入分类名称"
            ></el-input>
          </el-form-item>

          <el-form-item label="分类类型" prop="categoryType">
            <el-radio-group v-model="addForm.categoryType">
              <el-radio :label="1">课程分类</el-radio>
              <el-radio :label="2">资源分类</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="父分类" prop="parentId">
            <el-select
              v-model="addForm.parentId"
              placeholder="选择父分类（一级分类无需选择）"
              @change="handleParentChange"
            >
              <el-option label="无（一级分类）" value=""></el-option>
              <!-- 只显示同类型的上级分类，且三级分类不能作为父分类 -->
              <el-option
                v-for="item in parentOptions"
                :key="item.id"
                :label="item.categoryName"
                :value="item.id"
                :disabled="item.level >= 3"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="层级" prop="level">
            <el-input
              v-model="addForm.level"
              disabled
              placeholder="自动计算"
            ></el-input>
          </el-form-item>

          <el-form-item label="排序权重" prop="sort">
            <el-input
              v-model.number="addForm.sort"
              placeholder="数值越小越靠前，默认0"
              type="number"
            ></el-input>
          </el-form-item>

          <el-form-item label="状态" prop="status">
            <el-switch
              v-model="addForm.status"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </el-form-item>

          <el-form-item label="备注" prop="remark">
            <el-input
              v-model="addForm.remark"
              type="textarea"
              rows="3"
              placeholder="请输入备注说明（可选）"
            ></el-input>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="addCategory"
            :loading="btnLoading"
            :disabled="btnDisabled || addForm.level > 3"
          >
            确 定
            <template v-if="addForm.level > 3">（最多支持三级分类）</template>
          </el-button>
        </span>
      </el-dialog>

      <!-- 编辑对话框 -->
      <el-dialog
        title="编辑分类"
        :visible.sync="editDialogVisible"
        width="60%"
        @close="editClose"
      >
        <el-form
          :model="editForm"
          :label-position="labelPosition"
          :rules="formRules"
          ref="editFormRef"
          label-width="120px"
        >
          <el-input type="hidden" v-model="editForm.id"></el-input>
          <el-form-item label="分类名称" prop="categoryName">
            <el-input
              v-model="editForm.categoryName"
              placeholder="请输入分类名称"
            ></el-input>
          </el-form-item>

          <el-form-item label="分类类型" prop="categoryType">
            <el-radio-group v-model="editForm.categoryType" disabled>
              <el-radio :label="1">课程分类</el-radio>
              <el-radio :label="2">资源分类</el-radio>
            </el-radio-group>
            <div style="font-size: 12px; color: #888; margin-top: 5px">
              提示：分类类型创建后不可修改
            </div>
          </el-form-item>

          <el-form-item label="父分类" prop="parentId">
            <el-select
              v-model="editForm.parentId"
              placeholder="选择父分类"
              @change="handleEditParentChange"
              :disabled="editForm.level === 1"
            >
              <el-option label="无（一级分类）" value=""></el-option>
              <el-option
                v-for="item in parentOptions"
                :key="item.id"
                :label="item.categoryName"
                :value="item.id"
                :disabled="
                  item.id === editForm.id ||
                  item.level >= 3 ||
                  hasChildInPath(item.id, editForm.id)
                "
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="层级" prop="level">
            <el-input
              v-model="editForm.level"
              disabled
              placeholder="自动计算"
            ></el-input>
          </el-form-item>

          <el-form-item label="排序权重" prop="sort">
            <el-input
              v-model.number="editForm.sort"
              placeholder="数值越小越靠前"
              type="number"
            ></el-input>
          </el-form-item>

          <el-form-item label="状态" prop="status">
            <el-switch
              v-model="editForm.status"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </el-form-item>

          <el-form-item label="备注" prop="remark">
            <el-input
              v-model="editForm.remark"
              type="textarea"
              rows="3"
              placeholder="请输入备注说明（可选）"
            ></el-input>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="updateCategory"
            :loading="btnLoading"
            :disabled="btnDisabled || editForm.level > 3"
          >
            确 定
            <template v-if="editForm.level > 3">（最多支持三级分类）</template>
          </el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 基础状态
      loading: true,
      btnLoading: false,
      btnDisabled: false,
      labelPosition: "right",
      total: 0,

      // 对话框控制
      addDialogVisible: false,
      editDialogVisible: false,

      // 查询参数
      queryMap: {
        pageNum: 1,
        pageSize: 10,
        categoryName: "",
        categoryType: "",
        level: "",
        status: "",
      },

      // 数据列表
      categoryList: [], // 分类列表（带父分类名称）
      allCategories: [], // 所有分类（用于处理父分类名称和层级关系）

      // 父分类选择项（过滤掉三级分类和自身）
      parentOptions: [],

      // 表单数据
      addForm: {
        categoryName: "",
        categoryType: 1,
        parentId: "",
        level: 1,
        sort: 0,
        status: 1,
        remark: "",
      },
      editForm: {},

      // 表单验证规则
      formRules: {
        categoryName: [
          { required: true, message: "请输入分类名称", trigger: "blur" },
          {
            min: 1,
            max: 100,
            message: "分类名称长度在1-100个字符之间",
            trigger: "blur",
          },
        ],
        categoryType: [
          { required: true, message: "请选择分类类型", trigger: "change" },
        ],
        level: [{ required: true, message: "层级不能为空", trigger: "blur" }],
        sort: [
          { type: "number", message: "排序权重必须为数字", trigger: "blur" },
        ],
      },
    };
  },

  methods: {
    // 加载分类列表
    async getCategoryList() {
      this.loading = true;
      try {
        const { data: res } = await this.$http.get("courseCategory/list", {
          params: this.queryMap,
        });
        if (res.code !== 200) return this.$message.error("获取分类列表失败");

        this.categoryList = res.data.rows;
        this.allCategories = [...res.data.rows]; // 保存所有分类用于处理层级关系
        this.total = res.data.total;

        // 处理父分类名称显示
        this.formatParentCategoryName();
        // 生成父分类选择项
        this.generateParentOptions();
      } catch (error) {
        this.$message.error("获取数据失败，请重试");
      } finally {
        this.loading = false;
      }
    },

    // 格式化父分类名称
    formatParentCategoryName() {
      this.categoryList.forEach((item) => {
        if (item.parentId) {
          const parent = this.allCategories.find((p) => p.id === item.parentId);
          item.parentCategoryName = parent ? parent.categoryName : "【已删除】";
        } else {
          item.parentCategoryName = "无";
        }
      });
    },

    // 生成父分类选择项（用于添加/编辑时的下拉选择）
    generateParentOptions() {
      // 只保留同类型的非三级分类，且排除自身（编辑时）
      this.parentOptions = this.allCategories.filter((item) => {
        // 添加时：同类型、层级<3
        // 编辑时：额外排除自身ID
        const isSameType =
          !this.editForm.id || item.categoryType === this.editForm.categoryType;
        const isNotThreeLevel = item.level < 3;
        const isNotSelf = !this.editForm.id || item.id !== this.editForm.id;
        return isSameType && isNotThreeLevel && isNotSelf && item.status === 1;
      });
    },

    // 检查是否有子分类
    hasChildren(id) {
      return this.allCategories.some((item) => item.parentId === id);
    },

    // 检查父分类选择是否会形成循环引用（编辑时）
    hasChildInPath(parentId, currentId) {
      // 检查当前分类是否是父分类的子分类（避免循环）
      const checkChild = (id) => {
        const children = this.allCategories.filter(
          (item) => item.parentId === id
        );
        if (children.some((child) => child.id === currentId)) return true;
        for (const child of children) {
          if (checkChild(child.id)) return true;
        }
        return false;
      };
      return checkChild(parentId);
    },

    // 搜索分类
    searchCategory() {
      this.queryMap.pageNum = 1;
      this.getCategoryList();
    },

    // 重置查询条件
    reset() {
      this.queryMap = {
        pageNum: 1,
        pageSize: 10,
        categoryName: "",
        categoryType: "",
        level: "",
        status: "",
      };
      this.getCategoryList();
    },

    // 分页相关
    handleSizeChange(newSize) {
      this.queryMap.pageSize = newSize;
      this.getCategoryList();
    },
    handleCurrentChange(current) {
      this.queryMap.pageNum = current;
      this.getCategoryList();
    },

    // 父分类变更（添加时）
    handleParentChange(parentId) {
      if (parentId) {
        const parent = this.allCategories.find((item) => item.id === parentId);
        this.addForm.level = parent ? parent.level + 1 : 1;
      } else {
        this.addForm.level = 1; // 无父分类则为一级
      }
    },

    // 父分类变更（编辑时）
    handleEditParentChange(parentId) {
      if (parentId) {
        const parent = this.allCategories.find((item) => item.id === parentId);
        this.editForm.level = parent ? parent.level + 1 : 1;
      } else {
        this.editForm.level = 1; // 无父分类则为一级
      }
    },

    // 添加分类
    async addCategory() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return;
        if (this.addForm.level > 3) {
          return this.$message.warning("最多支持三级分类");
        }

        this.btnLoading = true;
        this.btnDisabled = true;
        try {
          const { data: res } = await this.$http.post(
            "courseCategory/add",
            this.addForm
          );
          if (res.code === 200) {
            this.$notify.success({ title: "成功", message: "分类添加成功" });
            this.addDialogVisible = false;
            this.getCategoryList();
          } else {
            this.$message.error("添加失败：" + res.msg);
          }
        } catch (error) {
          this.$message.error("添加失败，请重试");
        } finally {
          this.btnLoading = false;
          this.btnDisabled = false;
        }
      });
    },

    // 编辑分类
    async edit(id) {
      try {
        const { data: res } = await this.$http.get(`courseCategory/${id}`);
        if (res.code !== 200) return this.$message.error("获取分类详情失败");

        this.editForm = { ...res.data };
        // 生成适用于当前编辑项的父分类选项
        this.generateParentOptions();
        this.editDialogVisible = true;
      } catch (error) {
        this.$message.error("获取详情失败，请重试");
      }
    },

    // 更新分类
    async updateCategory() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return;
        if (this.editForm.level > 3) {
          return this.$message.warning("最多支持三级分类");
        }

        this.btnLoading = true;
        this.btnDisabled = true;
        try {
          const { data: res } = await this.$http.put(
            `courseCategory/update/${this.editForm.id}`,
            this.editForm
          );
          if (res.code === 200) {
            this.$notify.success({ title: "成功", message: "分类更新成功" });
            this.editDialogVisible = false;
            this.getCategoryList();
          } else {
            this.$message.error("更新失败：" + res.msg);
          }
        } catch (error) {
          this.$message.error("更新失败，请重试");
        } finally {
          this.btnLoading = false;
          this.btnDisabled = false;
        }
      });
    },

    // 删除分类
    async del(id) {
      // 检查是否有子分类
      if (this.hasChildren(id)) {
        return this.$message.warning("该分类下存在子分类，无法删除");
      }

      try {
        const confirm = await this.$confirm(
          "此操作将永久删除该分类，是否继续？",
          "警告",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        );

        if (confirm !== "confirm") return;

        const { data: res } = await this.$http.delete(
          `courseCategory/delete/${id}`
        );
        if (res.code === 200) {
          this.$notify.success({ title: "成功", message: "分类删除成功" });
          this.getCategoryList();
        } else {
          this.$message.error("删除失败：" + res.msg);
        }
      } catch (error) {
        if (error !== "cancel") {
          this.$message.error("删除失败，请重试");
        }
      }
    },

    // 切换状态
    async changeStatus(row) {
      const originalStatus = row.status;
      try {
        const { data: res } = await this.$http.put(
          `courseCategory/updateStatus/${row.id}/${row.status}`
        );
        if (res.code !== 200) {
          row.status = originalStatus; // 回滚状态
          return this.$message.error("状态更新失败：" + res.msg);
        }
        this.$notify.success({
          title: "成功",
          message: `分类已${row.status === 1 ? "启用" : "禁用"}`,
        });
      } catch (error) {
        row.status = originalStatus; // 回滚状态
        this.$message.error("状态更新失败，请重试");
      }
    },

    // 关闭添加对话框
    closeDialog() {
      this.$refs.addFormRef.clearValidate();
      this.addForm = {
        categoryName: "",
        categoryType: 1,
        parentId: "",
        level: 1,
        sort: 0,
        status: 1,
        remark: "",
      };
    },

    // 关闭编辑对话框
    editClose() {
      this.$refs.editFormRef.clearValidate();
      this.editForm = {};
    },

    // 获取Token
    getToken() {
      return localStorage.getItem("token") || "";
    },
  },

  created() {
    this.getCategoryList();
  },
};
</script>

<style scoped>
.upload-demo {
  margin-bottom: 10px;
}
.el-tag {
  margin-right: 0;
}
</style>
